<template>
  <v-dialog v-model="show" max-width="1200px" persistent>
    <v-card elevation="10" class="rounded-xl">
      <v-card-title
        class="d-flex justify-center align-center"
        style="background: linear-gradient(90deg, #f44336 0%, #ff9800 100%); color: white"
      >
        <v-icon color="white" large class="mr-2">mdi-alert-circle</v-icon>
        <span class="headline font-weight-bold">{{ title }}</span>
      </v-card-title>
      <v-card-text class="pa-6" style="background: #f9f9f9">
        <div class="text-center mb-4">
          <s-toolbar
            :label="message"
            color="#BAB6B5"
            :close="false"
            @close="handleClose"
            download
            @download="download()"
            style="color: white"
          />
        </div>
        <v-data-table
          dense
          v-if="items && items.length > 0"
          :items="items"
          :headers="dynamicHeaders"
          class="elevation-2 rounded-lg"
          hide-default-footer
        >
          <template
            v-for="header in dynamicHeaders"
            v-slot:[`item.${header.value}`]="{ item }"
          >
            <span v-if="header.html" v-html="item[header.value]"></span>
            <span v-else>{{ item[header.value] }}</span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="d-flex justify-center" style="background: #f5f5f5">
        <v-btn
          color="red darken-1"
          dark
          rounded
          @click="handleClose"
          class="px-6 py-2 font-weight-bold"
          >Cerrar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "ErrorDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Error al procesar",
    },
    message: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    customHeaders() {
      // Encabezados personalizados para la tabla solicitada
      return [
        { text: "Fecha", value: "Fecha" },
        { text: "DNI", value: "DNI" },
        { text: "Nombre", value: "Nombre" },
        { text: "Area", value: "Area" },
        { text: "Horas_Trab", value: "Horas_Trab" },
        { text: "Horas_Extras", value: "Horas_Extras" },
        { text: "H_Extras25", value: "H_Extras25" },
        { text: "H_Extras35", value: "H_Extras35" },
        { text: "HExtras_Dobles", value: "HExtras_Dobles" },
        { text: "HTrab_Noct", value: "HTrab_Noct" },
        { text: "HExtras_Noct25", value: "HExtras_Noct25" },
        { text: "HExtras_Noct35", value: "HExtras_Noct35" },
        { text: "Descanso_Feriado", value: "Descanso_Feriado" },
        { text: "Tipo_Suspension", value: "Tipo_Suspension" },
        { text: "H_Permiso", value: "H_Permiso" },
      ];
    },
  },
  computed: {
    dynamicHeaders() {
      // Si se pasan headers por props, usarlos
      if (this.headers && this.headers.length > 0) return this.headers;
      // Si no, generar headers dinámicamente según el primer item
      if (this.items && this.items.length > 0) {
        const first = this.items[0];
        return Object.keys(first)
          .filter((key) => this.items.some(item => item[key] !== undefined && item[key] !== null && item[key] !== ''))
          .map((key) => {
        // Si el valor contiene etiquetas html, marcar como html
        const isHtml = typeof first[key] === "string" && /<[^>]+>/.test(first[key]);
        return { text: key, value: key, html: isHtml };
          });
      }
      return [];
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("input", false);
      this.$emit("close");
    },
    download() {
      const cleanItems = this.items.map((row) => {
        let cleaned = {};
        this.dynamicHeaders.forEach((h) => {
          if (h.html) {
            if (!row[h.value]) cleaned[h.value] = "";
            else if (typeof row[h.value] === "string") {
              const tmp = document.createElement("DIV");
              tmp.innerHTML = row[h.value];
              cleaned[h.value] = tmp.textContent || tmp.innerText || "";
            } else {
              cleaned[h.value] = row[h.value];
            }
          } else {
            cleaned[h.value] = row[h.value];
          }
        });
        return cleaned;
      });

      const worksheet = XLSX.utils.json_to_sheet(cleanItems, {
        header: this.dynamicHeaders.map((header) => header.value),
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${this.title} ${this.$fun.formatDate(new Date(), "YYYYMMDD_HHmmss")}.xlsx`);
    },
  },
};
</script>
